import { Timestamp } from "firebase/firestore";

// ✅ Récupère un `Timestamp` Firestore pour l'instant actuel
export function getFlutterTime(): Timestamp {
  return Timestamp.now();
}

// ✅ Convertit un `Timestamp` Firestore en `Date`
export function getDateFromFlutter(timestamp: Timestamp): Date {
  if (!timestamp) {
    console.error("Timestamp manquant");
    return new Date();
  }
  return new Date(timestamp.seconds * 1000);
}

export function getLocalFromFlutter(timestamp: Timestamp): string {
  if (!timestamp) {
    console.error("Timestamp manquant");
    return "";
  }
  const date = new Date(timestamp.seconds * 1000);
  return date.toLocaleString("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function getHistoryDateFromFlutter(timestamp: Timestamp | string): string {
  if (!timestamp) {
    console.error("Timestamp manquant");
    return "";
  }
  // i want DD/MM à HH:mm
  let date: Date;
  if (typeof timestamp === 'string') {
    date = new Date(timestamp);
  } else {
    date = new Date(timestamp.seconds * 1000);
  }
  return date
    .toLocaleString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(" ", " à ");
}

export function getFlutterFromDate(date: Date): Timestamp {
  if (!date) {
    console.error("Date manquante");
    return Timestamp.now();
  }
  return Timestamp.fromDate(date);
}

export function getFlutterFromSeconds(seconds: number): Timestamp {
  let date = new Date(seconds * 1000);
  if (!seconds) {
    console.error("Seconds manquants");
    return new Timestamp(0, 0);
  }
  return Timestamp.fromDate(date);
}

/** Format an ISO date string (YYYY-MM-DD) as DD/MM/YYYY for display */
export function formatIsoDate(iso: string): string {
  if (!iso || iso.length < 10) return iso || "";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
}
